import { render, staticRenderFns } from "./promiseGoodsItemMngt.vue?vue&type=template&id=60e8d45c"
import script from "./promiseGoodsItemMngt.vue?vue&type=script&lang=js"
export * from "./promiseGoodsItemMngt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports